import { Icon } from "components/Icon/Icon";
import styled from "styled-components/macro";
import type { ElearningTheme } from "themes/elearning.theme";

interface Props {
  theme: ElearningTheme;
}

export const StyledDownloadButton = styled.div<Props>`
  display: flex;
  align-items: center;
  height: 48px;
  padding: 0px 16px;
  border-radius: 4px;
  cursor: pointer;
  background-color: ${(props: Props) => props.theme.palette.primary.brand};
  color: ${(props: Props) => props.theme.palette.neutral.white};
`;

export const StyledIcon = styled(Icon)<Props>`
  font-size: 24px;
  margin-right: 10 px;
`;
